import fetchData from 'src/utils/fetchData';

export const getAccountProfileAPI = async () => {
  return fetchData('/ui/front-api/private/account/profile');
};

export const putAccountProfileAPI = async (data: any) => {
  return fetchData('/ui/front-api/private/account/profile', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
};

export const postSetPasswordAPI = async (data: any) => {
  return fetchData('/ui/front-api/private/account/set-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: data,
  });
};

export const postStartEmailConfirmationAPI = async () => {
  return fetchData('/ui/front-api/private/account/start-email-confirmation', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const postConfirmEmailAPI = async (data: any) => {
  return fetchData('/ui/front-api/public/account/confirm-email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: data,
  });
};
